const LetterPaperLayoutTypes = {
  DOCUMENT_MAIN: 'document-main',
  DOCUMENT_MAIN_PAGEBREAK: 'document-main-pageBreak',
  DOCUMENT_MAIN_BORDER: 'document-main-border',
  DOCUMENT_MAIN_BORDER2: 'document-main-border2',
  DOCUMENT_INFO_BLOCK: 'document-main-infoBlock',
  DOCUMENT_INFO_BLOCK2: 'document-main-infoBlock2',
  DOCUMENT_MAIN_ENGLISH: 'document-main-english',
}

export default Object.freeze(LetterPaperLayoutTypes)
